import * as yup from 'yup';

export const mediaSchema = yup.object().shape({
  albumName: yup
    .string()
    .required('Album name is required')
    .min(2, 'Album name must be at least 2 characters')
    .transform((value: string) => value.replace(/\s+/g, ' ').trim()),
});
